import { Navigate } from "react-router";

import { useAuthStore } from "@/client/stores/auth";

export const HomePage = () => {
  const isLoggedIn = useAuthStore((state) => !!state.user);

  // Redirect to dashboard if logged in, otherwise to login
  if (isLoggedIn) {
    return <Navigate to="/dashboard/resumes" replace />;
  }

  return <Navigate to="/auth/login" replace />;
};
